module.exports = __webpack_public_path__ + "static/serviceDesign-a176aed3d74d005661e9e05a20d22bb4.png";